import { CRM_API, RequestHelper } from "utils";

const RUTA = "condicionPago";
export const CondicionPagoService = (() => {
  const buscarPorId = function (args, esLookup) {
    return new Promise((res) => res(args)).then((Id) => {
      return RequestHelper(CRM_API).get(`${RUTA}/buscarPorId`, {
        Id: Id,
        esLookup: esLookup,
      });
    });
  };

  const listado = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).get(`${RUTA}/listar`, params);
    });
  };

  const crear = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).post(`${RUTA}/crear`, data);
    });
  };

  const actualizar = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).post(`${RUTA}/actualizar`, data);
    });
  };

  const exportarExcel = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).post(`${RUTA}/ExportarExcel`, params, true);
    });
  };

  return {
    listado,
    crear,
    actualizar,
    buscarPorId,
    exportarExcel, 
  };
})();
